import request from './request'

export function getMediaList(params) {
  return request({
    url: '/media',
    method: 'get',
    params
  })
}

export function uploadMedia(formData) {
  return request({
    url: '/media',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function deleteMedia(id) {
  return request({
    url: `/media/${id}`,
    method: 'delete'
  })
}

export function batchDeleteMedia(ids) {
  return request({
    url: '/media/batch-delete',
    method: 'post',
    data: { ids }
  })
}